export default function parsePriceToNumber(price) {
   return parseFloat(price?.replace('.', '').replace(',', '.'));
}
